var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterColored = function SvgTwitterColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A4F9",
    d: "M18.14 2.315a7.1 7.1 0 0 1-2.048.56A3.57 3.57 0 0 0 17.66.904a7.1 7.1 0 0 1-2.265.866A3.565 3.565 0 0 0 9.32 5.02a10.12 10.12 0 0 1-7.35-3.726 3.55 3.55 0 0 0-.482 1.793c0 1.237.63 2.329 1.586 2.968A3.56 3.56 0 0 1 1.46 5.61v.045a3.57 3.57 0 0 0 2.86 3.496 3.6 3.6 0 0 1-1.61.06 3.57 3.57 0 0 0 3.33 2.477 7.15 7.15 0 0 1-5.278 1.476 10.1 10.1 0 0 0 5.465 1.602c6.559 0 10.145-5.433 10.145-10.145q0-.231-.01-.461a7.2 7.2 0 0 0 1.779-1.845"
  })));
};
export default SvgTwitterColored;